// @ts-nocheck
import { z } from "zod";
export const slotPartSchema = z.object({ "name": z.string(), "description": z.string(), "scripted_questions": z.array(z.string()).optional() });
